module.exports = __webpack_public_path__ + "3ea51c4fb2b195af4733b88b8c3ecc10.pdf";